import { CoverConfig } from 'game/extended/heros/ranger/cover/cover'

export const cover_config: Array<CoverConfig> = [
    {
        reload: 4
    },
    {
        reload: 2
    }
]